import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ACTIONS, ICardDesign } from './type';
import { IAction } from '../../models/common';
import { getCardCategoriesApi, getCardDesignApi, getGiftCardApi, giftPromoApi } from '../../services/giftshop';
import { getCardCategoryError, getCardCategorySuccess, getCardDesignError, getCardDesignSuccess, getGiftCardError, getGiftCardPromoError, getGiftCardPromoSuccess, getGiftCardSuccess } from './action';
import moment from 'moment';
import { formatGiftCard } from '../../utils/giftshop';

function* getCardDetails(action: IAction): any {
    let { payload } = action

    const [giftCard, giftPromo] = yield all([
      call(getGiftCardApi, payload),
      call(giftPromoApi, {cinemaId: payload?.cinemaId}),
    ]);
    const { data, error } = giftCard;
    if (data && (data.giftcards || data.Items)) {

        /** Updating promo on state */
        const promoData = giftPromo?.data;
        if (promoData) {
            yield put(getGiftCardPromoSuccess(promoData));
        } else {
            yield put(getGiftCardPromoError({}));
        }

        /** updating Cards on state */
        const {Items} = data;
        
        yield put(getGiftCardSuccess(Items ? Items : []));
    } else {
        yield put(getGiftCardError(error));
    }
}
function* getCardDesigns(action: IAction) {
    const { payload } = action;
    const { data, error } = yield call(getCardDesignApi, payload);
    if (data) {
        let { Items } = data;
        if(Items.length > 0){
            Items = Items.filter((v: ICardDesign)=>!(v.archive === 1 && moment(v.expiry_date) < moment())).sort((a:ICardDesign,b:ICardDesign)=>a.sortorder - b.sortorder)
        }
        yield put(getCardDesignSuccess(Items))
    } else {
        yield put(getCardDesignError(error))
    }
}


function* getCardCategory(action: IAction) {
    let { payload } = action
    const { data, error } = yield call(getCardCategoriesApi, payload)
    if (data) {
        const { Items } = data;
        yield put(getCardCategorySuccess(Items));
    } else {
        yield put(getCardCategoryError(error));
    }
}

function* getGiftPromo(action: IAction) {
    let { payload } = action

    const { data } = yield call(giftPromoApi, payload)
    if (data) {
        yield put(getGiftCardPromoSuccess(data));
    } else {
        yield put(getGiftCardPromoError({}));
    }
}

export function* giftshopWatcher() {
    yield takeLatest(ACTIONS.GET_CARD_WATCHER, getCardDetails);
    yield takeLatest(ACTIONS.GET_CARD_DESIGN_WATCHER, getCardDesigns);
    yield takeLatest(ACTIONS.GET_CARD_CATEGORY_WATCHER, getCardCategory)
    yield takeLatest(ACTIONS.GIFT_CARD_PROMO_WATCHER, getGiftPromo);
}